import normalizer from "normalizer";

let NibaraInstance = (function (window) {
  var app = Voonto.getInstance();

  let nTools = {};
  const nodes = {
    0: "static",
    1: "static1",
    2: "static2",
    3: "static3",
    4: "static4"
  };

  nTools.getStaticNode = function (url) {
    if (window.location.href.match('docker|des-') !== null) {
      return url;
    }
    let mod = url.length % 5;
    if (url.match('static.abc.es')) {
      url = url.replace('static', nodes[mod]);
      //Logger.debug('static host modified: ' + url);
    }
    return url;
  };

  nTools.cleanerUrl = function (url, marks = true, parameters = true) {
    if (marks) { //clean marcas de tags o tracking
      url = url.replace(/#\w.*/g, '');
    }
    if (parameters) {
      url = url.replace(/\?.*/g, '');
    }
    return url;
  };

  nTools.getUrlParams = function () {

    let params = {};
    let queryParams = window.location.search.length > 0 ? window.location.search.substr(1).split('&') : '';
    let queryHash = window.location.hash.length > 0 ? window.location.hash.substr(1).split('&') : '';

    let queryVars = {};
    for (let i = 0; i < queryParams.length; i++) {
      let hash = queryParams[i].split('=');

      if (hash.length > 1) {
        queryVars[hash[0]] = hash[1];
      } else {
        queryVars[hash[0]] = null;
      }
    }
    params.queryParams = queryVars;

    let hashVars = {};
    for (let i = 0; i < queryHash.length; i++) {
      let hash = queryHash[i].split('=');

      if (hash.length > 1) {
        hashVars[hash[0]] = hash[1];
      } else {
        hashVars[hash[0]] = null;
      }
    }
    params.queryHash = hashVars;

    return params;
  };

  nTools.getUrlParam = function getUrlParam(name) {
    let i, hash, hashes;
    hashes = window.location.search.slice(1).split('&');
    for (i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      if (hash[0] === name) {
        return hash.length > 1 ? hash[1] : '';
      }
    }
    hashes = window.location.hash.slice(1).split('&');
    for (i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      if (hash[0] === name) {
        return hash.length > 1 ? hash[1] : '';
      }
    }

    return null;
  };

  /**
   * Return boolean if nested item exists
   * Use: (obj, 'level1', 'level2', ... 'levelN')
   * @param obj
   * @return {boolean}
   */
  nTools.isset = function (obj /*, level1, level2, ... levelN*/) {
    let args = Array.prototype.slice.call(arguments, 1);

    for (let i = 0; i < args.length; i++) {
      if (!obj || !obj.hasOwnProperty(args[i])) {
        return false;
      }
      obj = obj[args[i]];
    }
    return true;
  };

  /**
   * KebabCase string
   * @param str
   * @return {string | *}
   */
  nTools.kebabCase2 = function (str) {
    let result;

    // Convierte mayus. camelCase a kebab-case.
    result = str.replace(/([a-z][A-Z])/g, function (match) {
      return match.substr(0, 1) + '-' + match.substr(1, 1);
    });

    result = result.toLowerCase();

    /* Convierte no caracteres alfanumericos en '+' */
    result = result.replace(/[^-a-z0-9áéíóúàèìòùüÜñÑ]{1}/g, '+');

    return result;
  };

  /* Returns a function, that, when invoked, will only be triggered at most once
   * during a given window of time. Normally, the throttled function will run
   * as much as it can, without ever going more than once per `wait` duration */
  nTools.throttle = function(wait, func) {
    let timeout, context, args, result;
    let previous = 0;

    let later = function() {
      previous = Date.now();
      timeout = null;
      result = func.apply(context, args);
      context = args = null;
    };

    let throttled = function() {
      let now = Date.now();
      let remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        context = args = null;
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    return throttled;
  };

  nTools.createCookieByName = function(name,content, expTime) {
      let expires = new Date();
      expires.setTime(expires.getTime() + parseInt(expTime));
      let cookie = name + "=" + content + ";expires=" + expires.toUTCString() +";path=/";
      //Logger.debug("[" + name + " creada]");
      return document.cookie = cookie;
  };

  nTools.removeCookieByName = function(name, content, expTime) {
      let expires = new Date();
      expires.setTime(expires.getTime() - parseInt(expTime));
      let cookie = name + "=" + content + ";expires=" + expires.toUTCString() +";path=/";
      //Logger.debug("[" + name + " eliminada]");
      return document.cookie = cookie;
  };

  nTools.getContentCookie = function (name){
      let value = "; " + document.cookie;
      let parts = value.split("; " + name + "=");
      if (parts.length >= 2) {
        return parts.pop().split(";").shift();
      }else{
        return '';
      }
  };

  /**
   * Obtienen la Seccion de la Variable de Comscore
   * @returns {*}
   */
  nTools.getSectionComscore = function() {
    return window.vocento.tracking.comscore.voc_se;
  };
  /**
   * obtiene la Seccion a partir de la Url
   * @returns {*|string}
   */
  nTools.getSectionUrl = function() {
    let url = nTools.parseUrl(nTools.cleanerUrl(window.location.href));
    let pathName = url.pathname;
    let section = '';
    if (pathName == '' || pathName == '/') {
      section="home";
    } else {
      section = pathName.split("/")[1];
    }

    return section;
  };

  /**
   * Retorna un Objecto de Tipo Url Parse, con los datos de la url del parametro
   * @param url
   * @returns {{protocol: *, host: *, hostname: *, port: *, pathname: *, hash: *, search: *, origin: *}}
   */
  nTools.parseUrl = function (url) {
    let parser = document.createElement('a');
    parser.href = url;
    return {
      protocol:parser.protocol,
      host:parser.host,
      hostname:parser.hostname,
      port:parser.port,
      pathname:parser.pathname,
      hash:parser.hash,
      search:parser.search,
      origin:parser.origin
    }
  };
  /**
   * Verifica si Existe la Cookie de Gigya del Login.
   * @returns {void|RegExpMatchArray|*}
   */
  nTools.isLoginCookie = function () {
    return window.document.cookie.match(/^(.*;)?\s*voc_uid\s*=\s*[^;]+(.*)?$/);
  };

  /**
   *  Verifica siExiste el Objeto de Gigya y si esta Cargado vocUser Este método es un poco mas lento
   *  que el usuado por la Cookie, pero Utiliza La Instancia de Gigya
   * @returns {PromiseLike<boolean | never> | Promise<boolean | never> | *}
   */
  nTools.isLoginGigya = function () {
    return app.when('vocuser:ready').then(function(gigyaUX) {
      return  typeof gigyaUX !== 'undefined' && gigyaUX.getUserType() !== 'anonimo';
    });
  };

  nTools.gigyaUxReady = function () {
    return Voonto.getInstance().when('vocuser:ready').then(function(gigyaUX) {
          return gigyaUX;
    });
  };
  /**
   * Actualiza la Publi segun el Id y la Poscición que se le indique
   * @param eid Id de la posisción de publi a refrescar (robapaginas_dos-id, boton_native-id, ... etc)
   * @param pos Posición de la publi que se va a refrescar (robapaginas_dos, boton_native  ... etc)
   */
  nTools.refreshPubli = function (eid, pos) {
    let data = {};
    if(typeof eid !== "undefined"){
      data = {"id": eid, "position": pos, "refresh": true};
      app.trigger('vam:refresh', data);
      //Logger.debug('[nTools] -- Refresh Publi', data);
    }
    return data;
  };

  nTools.kebabCase = function (string) {
    var result = string;
    // Convert camelCase capitals to kebab-case.
    result = result.replace(/([a-z][A-Z])/g, function(match) {
      return match.substr(0, 1) + '-' + match.substr(1, 1);
    });
    // Convert non-camelCase capitals to lowercase.
    result = result.toLowerCase();
    // Convert non-alphanumeric characters to hyphens
    result = result.replace(/[^-a-z0-9]+/g, '-');
    // Remove hyphens from both ends
    result = result.replace(/^-+/, '').replace(/-$/, '');
    return result;
  };

  /**
   * Verifica si el json que se recibe es correcto o no.
   * @param string
   */
  nTools.checkIsValidJson = function (string) {
    try {
      JSON.parse(string);
    } catch (e) {
      return false;
    }
    return true;
  };

  nTools.normalizer = function (str, caps = false) {
    return normalizer.normalize (str, caps);
  };

  nTools.isPremium = function() {
    return typeof window.voc_ate !== 'undefined' && window.voc_ate === 'si';
  }

  /* Ajuste de Politicas de Cookies salga la configuración de preferencias */
  /* lo agregamos de manera general para todos, portadas, noticias todos! */
  Voonto.$('.politica-cookie').on('click',function(e){
    //Logger.debug('[conf-cookie] ejecutando..');
    e.preventDefault();
    Voonto.cmp.show();

    return false;
  });

  return {
    app: app,
    nTools: nTools
  }

}(window));

window.nibara = NibaraInstance;



// WEBPACK FOOTER //
// ./src/nibara.js